module.exports = __webpack_public_path__ + "img/xxl.d009a3ba.png";